/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloConvexStateChangesHandler,
  SiloConvexStateChangesHandlerInterface,
} from "../SiloConvexStateChangesHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepo",
        type: "address",
      },
      {
        internalType: "contract IConvexSiloWrapperFactory",
        name: "_wrapperFactory",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidConvexSiloWrapperFactory",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepo",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidWrapper",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlySilo",
    type: "error",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SILO_REPOSITORY",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WRAPPER_FACTORY",
    outputs: [
      {
        internalType: "contract IConvexSiloWrapperFactory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_firstToCheckpoint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_secondToCheckpoint",
        type: "address",
      },
    ],
    name: "beforeBalanceUpdate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISiloLike",
        name: "",
        type: "address",
      },
    ],
    name: "cachedSiloWrappers",
    outputs: [
      {
        internalType: "contract IConvexSiloWrapper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wrapper",
        type: "address",
      },
    ],
    name: "checkUnderlyingToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SiloConvexStateChangesHandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloConvexStateChangesHandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloConvexStateChangesHandler__factory extends ContractFactory {
  constructor(...args: SiloConvexStateChangesHandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloConvexStateChangesHandler";
  }

  deploy(
    _repository: string,
    _fetchersRepo: string,
    _wrapperFactory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloConvexStateChangesHandler> {
    return super.deploy(
      _repository,
      _fetchersRepo,
      _wrapperFactory,
      overrides || {}
    ) as Promise<SiloConvexStateChangesHandler>;
  }
  getDeployTransaction(
    _repository: string,
    _fetchersRepo: string,
    _wrapperFactory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _fetchersRepo,
      _wrapperFactory,
      overrides || {}
    );
  }
  attach(address: string): SiloConvexStateChangesHandler {
    return super.attach(address) as SiloConvexStateChangesHandler;
  }
  connect(signer: Signer): SiloConvexStateChangesHandler__factory {
    return super.connect(signer) as SiloConvexStateChangesHandler__factory;
  }
  static readonly contractName: "SiloConvexStateChangesHandler";
  public readonly contractName: "SiloConvexStateChangesHandler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloConvexStateChangesHandlerInterface {
    return new utils.Interface(_abi) as SiloConvexStateChangesHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloConvexStateChangesHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as SiloConvexStateChangesHandler;
  }
}
